<template>
  <div class="nkn-mining-intro">
    <div class="common-title">{{$t("miner.title")}}</div>

    <!--<div class="common-sub-title">{{$t("miner.miningIntro.title")}}</div>-->
    <div class="mining-video-module">
      <div class="video-title">{{$t("miner.miningIntro.vtitle")}}</div>
      <video-player class="video-body mining-intro-flag" :options="playerOptions" :playsinline="true"></video-player>
    </div>
  </div>
</template>

<script>
  import 'video.js/dist/video-js.css'
  import {
    videoPlayer
  } from 'vue-video-player'
  import {
    mapState
  } from 'vuex'
  import videoMix from '@/assets/js/nknVideoMix.js'

  export default {
    components: {
      videoPlayer
    },
    computed: {
      ...mapState({
        lang: state => state.lang.lang
      })
    },
    mixins: [videoMix],
    data: function () {
      let playerOptions = {}
      if (this.$i18n.locale === 'zh') {
        playerOptions = {
          autoplay: false,
          muted: false,
          language: 'en',
          fluid: true,
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: this.$url.VIDEOLINKEN.mining
          }],
          poster: '/static/img/miner/NKN-60s-Chinese.png'
        }
      } else {
        playerOptions = {
          autoplay: false,
          muted: false,
          language: 'en',
          fluid: true,
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: this.$url.VIDEOLINKEN.mining
          }],
          poster: '/static/img/miner/Mining-video.jpg'
        }
      }
      return {
        playerOptions
      }
    },
    watch: {
      lang: function () {
        if (this.$i18n.locale === 'zh') {
          this.playerOptions = {
            autoplay: false,
            muted: false,
            language: 'en',
            fluid: true,
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            preload: 'none',
            sources: [{
              type: 'video/mp4',
              src: this.$url.VIDEOLINKEN.mining
            }],
            poster: '/static/img/miner/NKN-60s-Chinese.png'
          }
        } else {
          this.playerOptions = {
            autoplay: false,
            muted: false,
            language: 'en',
            fluid: true,
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            preload: 'none',
            sources: [{
              type: 'video/mp4',
              src: this.$url.VIDEOLINKEN.mining
            }],
            poster: '/static/img/miner/Mining-video.jpg'
          }
        }
        this.videoSet(this.playerOptions, 'mining')
      }
    },
    mounted() {
      this.videoSet(this.playerOptions, 'mining')
    }
  }
</script>

<style lang="scss" scoped>
  .nkn-mining-intro {
    @include common-inner();

    .common-sub-title {
      padding: 0 100px;
    }

    .mining-video-module {
      margin-top: 2rem;

      .video {
        &-title {
          @include nkn-font-set(1rem, $common-color);
          line-height: 1rem;
          padding-top: 40px;
          @media screen and (max-width: 768px) {
            padding-left: 15px;
          }
        }

        &-body {
          margin: 0 auto;
          margin-top: 10px;
          width: 100%;
          height: auto;

          @media screen and (min-width: 768px) {
            width: 50%;
            margin-left: 0;
            margin-top: 20px;
          }

          @media screen and (max-width: 768px) {
            width: 345px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/miner/nknMiningIntro.vue